import moment from 'moment/moment';
import momentTz from 'moment-timezone';

export const DISPLAY_DATE_FORMAT = 'DD/MM/YYYY';
export const DISPLAY_DATE_TIME_FORMAT = `${DISPLAY_DATE_FORMAT} HH:mm`;
export const API_DATE_FORMAT = 'YYYY-MM-DD';
export const API_DATE_TIME_FORMAT = `${API_DATE_FORMAT} HH:mm`;
export const FLATPICKR_API_DATE_FORMAT = 'Y-m-d';
export const FLATPICKR_API_DATE_TIME_FORMAT = `${FLATPICKR_API_DATE_FORMAT} H:i`;
export const FLATPICKR_DISPLAY_DATE_FORMAT = 'd/m/Y';
export const FLATPICKR_DISPLAY_DATE_TIME_FORMAT = `${FLATPICKR_DISPLAY_DATE_FORMAT} H:i`;

const isEmptyDate = (date) => date === null || date === undefined || date === '';

export const formatDisplayDate = (date, fallback = '') => {
  if (isEmptyDate(date)) {
    return fallback;
  }

  const momentDate = moment(date);
  return momentDate.isValid() ? momentDate.format(DISPLAY_DATE_FORMAT) : fallback;
};

export const formatDisplayDateTime = (date, fallback = '') => {
  if (isEmptyDate(date)) {
    return fallback;
  }

  const momentDate = moment(date);
  return momentDate.isValid() ? momentDate.format(DISPLAY_DATE_TIME_FORMAT) : fallback;
};

export const getRawData = (date = '') => date?.substring(0, 10);
export const getRawTime = (date = '') => date?.substring(11, 16);

export const formatDateToTimeZone = (date, timezone) => {
  let momentDate;
  if (date) {
    momentDate = momentTz(date);
  }
  if (timezone) {
    momentDate = momentDate.tz(timezone, false);
  }
  return momentDate;
};

export const formatDate = (date) => {
  const formattedDate = getRawData(date?.toISOString(true));
  const hours = moment(date).hours();
  const minutes = moment(date).minutes();

  return `${formattedDate}T${hours}:${`${minutes}`.length === 1 ? `0${minutes}` : minutes}:00Z`;
};

export const createExactDate = (dateTime) =>
  new Date(
    dateTime.year(),
    dateTime.month(),
    dateTime.date(),
    dateTime.hours(),
    dateTime.minutes(),
    dateTime.seconds(),
  );

export const getInitialDate = (date, timezone) => {
  if (date) {
    return formatDate(createExactDate(formatDateToTimeZone(date, timezone)));
  }
  return '';
};
